import { DefaultRsvpSettings, EventMediaData, EventMediaSchema, RsvpSettingsData, RsvpSettingsSchema } from ".";
import * as yup from "yup";
import { ScheduledAbstractItem } from "../../models/abstract";
import { ReactSelectOption } from "../../models/generic";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";

export interface SubEventData {
    active: boolean;
    description?: string;
    endDate: Date | null;
    id: number;
    isSession: boolean;
    locationName?: string;
    media: EventMediaData[];
    parentId: number;
    rsvp: RsvpSettingsData;
    scheduledAbstract: ScheduledAbstractItem | ReactSelectOption | null;
    startDate: Date | null;
    title: string;
    typeId: number | null;
}

export class SubEvent implements FormValidationModel<SubEventData> {
    public data: SubEventData;
    public rules: yup.Schema<SubEventData>;

    public constructor() {
        this.data = {
            active: true,
            description: "",
            endDate: null,
            id: 0,
            isSession: false,
            locationName: "",
            media: [],
            parentId: 0,
            rsvp: { ...DefaultRsvpSettings },
            scheduledAbstract: null,
            startDate: null,
            title: "",
            typeId: null,
        };
        this.rules = yup.object<SubEventData>().shape({
            active: yup.bool().label("Active"),
            description: yup.string().label("Description").nullable(true),
            endDate: yup.date().label("Ends on").nullable(true).required(),
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            isSession: yup.bool(),
            locationName: yup.string().label("Location name").nullable(true).max(150),
            media: yup.array().of(EventMediaSchema).label("Documents"),
            parentId: yup.number(),
            rsvp: RsvpSettingsSchema,
            scheduledAbstract: ReactSelectOptionSchema.label("Scheduled abstract").nullable(true),
            startDate: yup.date().label("Starts on").nullable(true).required(),
            title: yup.string().required().label("Title").max(255),
            typeId: yup.number().nullable(true).label("Type"),
            // typeId: yup.number().nullable(true).label("Type").when(["isSession"], (isSession: boolean) => {
            //     const schema = yup.number().nullable(true).label("Type");
            //     return isSession
            //         ? schema
            //         : schema.required();
            // }),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminEvent/SubEvent.ts